export default __webpack_public_path__ + "static/media/mascot-cosmic-drive.1778c517.gif";